import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupExclude: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBooleanGroupExclude"><Path fillRule="evenodd" clipRule="evenodd" d="M16 16H19C20.6569 16 22 14.6569 22 13V5C22 3.34315 20.6569 2 19 2H11C9.34315 2 8 3.34315 8 5V8H5C3.34315 8 2 9.34315 2 11V19C2 20.6569 3.34315 22 5 22H13C14.6569 22 16 20.6569 16 19V16ZM8 8H13C14.6569 8 16 9.34315 16 11V16H11C9.34315 16 8 14.6569 8 13V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupExclude;
